import BackMenu from './back-menu.vue'
import MainHeader from './main-header.vue'

export function importComponent(Vue) {
	Vue.component('back-menu', BackMenu),
	Vue.component('main-header', MainHeader)
}
